import axios from "axios";
import { header } from "../../services/getcookie";

const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 15000,
});

apiClient.interceptors.request.use(
  (config) => {
    // Attach headers globally using the Mawalog cookie strategy
    const headers = header();
    if (headers) {
      Object.assign(config.headers, headers);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Session management: Handle unauthorized access
    if (error.response?.status === 401) {
      console.warn("Unauthorized API call. Clearing session and redirecting.");
      localStorage.clear();
      document.cookie = "mawalog=; path=/; domain=.mawalog.com";
      if (accountsUrl) {
        window.location.href = accountsUrl;
      } else {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

const pendingGetRequests = new Map();

export const apiRequest = async ({
  method,
  url,
  data = {},
  params = {},
  headers,
}) => {
  const isGet = method && method.toLowerCase() === "get";
  const requestKey = isGet ? `${url}:${JSON.stringify(params)}` : null;

  if (isGet && pendingGetRequests.has(requestKey)) {
    return pendingGetRequests.get(requestKey);
  }

  const fetchPromise = (async () => {
    try {
      const response = await apiClient({
        method,
        url,
        data,
        params,
        ...(headers && { headers }),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    } finally {
      if (isGet) {
        pendingGetRequests.delete(requestKey);
      }
    }
  })();

  if (isGet) {
    pendingGetRequests.set(requestKey, fetchPromise);
  }

  return fetchPromise;
};
